export const main = {
  notice: 'Order and management solutions for restaurants',
  notice_2: 'a website or webshop for your restaurant in minutes',

  logo_alt: 'Bistroo',
  login_text: 'Log in',
  login_text_mobile: 'Restaurant log in',
  start_free_text: 'Start for free',

  actions: {
    create_your_shop: 'Create your webshop',
    product_demo: 'Product demo',
  },

  menu: {
    home: {
      text: 'Home',
    },
    products: {
      text: 'Products',
      submenu: {
        manager: {
          text: 'Bistroo Manager',
          subtext: 'All tools fully under your own control',
        },
        qr: {
          text: 'Bistroo QR',
          subtext: 'A cost-efficient table ordering process',
        },
        webshop: {
          text: 'Bistroo Webshop',
          subtext: 'The webshop for your restaurant',
        },
        pos: {
          text: 'Bistroo POS',
          subtext: 'Super-fast POS for quick-service',
        },
        posdevice: {
          text: 'Bistroo Device',
          subtext: 'Plug & play ordering and printing',
        },
        page: {
          text: 'Bistroo Website',
          subtext: 'Create a website in minutes',
        },
        kiosk: {
          text: 'Bistroo Kiosk',
          subtext: 'Self-service in your restaurant',
        },
      },
    },
    prices: {
      text: 'Pricing',
    },
    cases: {
      text: 'Cases',
      submenu: {
        cafetaria: {
          text: "Cafetaria D'n Boom",
          subtext: 'How Bistroo helped increase revenue.',
        },
        grillroom: {
          text: 'Grillroom Istanbul',
          subtext: 'Finally a fair business model.',
        },
        sushi: {
          text: 'Sushi De Wethouder',
          subtext: 'A partner we can trust 24/7.',
        },
        italian: {
          text: 'Italian Il Municipio',
          subtext: 'A new solution and opportunities.',
        },
        lunchroom: {
          text: 'Lunchroom Two-B',
          subtext: 'We saved a lot of time and frustration.',
        },
      },
    },
    info: {
      text: 'Info',
      submenu: {
        helpcenter: {
          text: 'Help Center',
          subtext: 'All the information you need',
        },
        integrations: {
          text: 'Integrations',
          subtext: 'Our partner integrations',
        },
        downloads: {
          text: 'Downloads',
          subtext: 'The latest app updates',
        },
        articles: {
          text: 'Articles',
          subtext: 'Latest industry updates',
        },
        faq: {
          text: 'FAQ',
          subtext: 'Most asked questions',
        },
        blog: {
          text: 'Blog',
          subtext: 'Current info & trends',
        },
        support: {
          text: 'Customer service',
          subtext: 'We are happy to help you',
        },
        contact: {
          text: 'Contact',
          subtext: 'We are happy to help you',
        },
      },
    },
  },
  cta_block: {
    open_your_webshop_today: 'Open your shop today.',
    its_free: "It's free!",
    start_generating_more_orders: 'Generate your first order within minutes',
    get_started_for_free: 'Get started for free',
  },
  footer: {
    general: 'General',
    products: 'Products',
    cases: 'Cases',
    info: 'Information',
  },
  product_faq: {
    label: 'Frequently asked questions',
    not_listed: 'Can\'t find your question? Contact our support team.',
  },
  integration: {
    back_link: 'All integrations',
    advantages_label: 'Benefits',
    setup_label: 'Set up in 5 steps',
    faq_heading: 'Frequently asked questions',
    more_info: 'More info',
    check_1: 'No obligation, cancel monthly',
    check_2: 'Set up in minutes',
    advantages_subtitle: 'Powerful features that work together seamlessly to streamline your restaurant operations',
    cta_footer_text: 'Set up in less than 10 minutes · Cancel anytime',
    related: {
      eyebrow: 'See also',
      title: 'Related integrations',
      description: 'Bistroo works with the best tools. Combine multiple integrations for a fully automated restaurant operation.',
    },
    cta: {
      heading: 'Open your shop today.',
      free: 'Free.',
      subtext: 'More orders, less work.',
      button: 'Get started for free',
    },
  },
}
